import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const getCharacterCloths = async (id, category, sort) => {
  try {
    const res = await axiosInstance.get(API_ROUTES.Character.cloths.replace(':characterId', id), {
      params: {
        category,
        ...sort
      }
    })
    if (res.data.success) {
      return res.data.items
    }
    return []
  } catch (error) {
    return false
  }
}
